export function numberWithCommas(x: number) {
  return Number(x).toLocaleString("en-US", {
    minimumFractionDigits: 2,
  });
}

export function currencyConverter(val: string) {
  switch (val) {
    case "NGN":
      return "₦";
    case "USD":
      return "$";

    default:
      return val;
  }
}
